// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22661","right":"styles_right__P8nki"};